// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dock';

export const Component = () => (
  <path d='M22.715 2.285c.38.38.38.996 0 1.376l-5.954 5.953h4.041a.973.973 0 1 1 0 1.946h-7.296V4.23a.973.973 0 0 1 1.945 0v3.942l5.888-5.887a.973.973 0 0 1 1.376 0ZM11.527 13.473v7.296a.973.973 0 1 1-1.946 0v-3.975l-5.92 5.921a.973.973 0 1 1-1.376-1.376l5.92-5.921H4.231a.973.973 0 1 1 0-1.945h7.296Z' />
);

export const viewBox = '0 0 25 25';
